import { Avatar } from "@mui/material";
import styles from "../orgListCard.module.scss";
import { ORG_AVATAR_COLOR } from "src/variable/randomColor";
import AdminSwitchOrg from "src/components/adminSwitchOrg/AdminSwitchOrg";
import { DateStack } from "src/components/UI/transactionCells";
import { orgList } from "src/page/organisation/organisationSlice";
import { EMPTY_STRING } from "src/components/constant/constant";

// The id / display-id columns an internal-admin flag used to add here were
// dropped at the client's request, so the list is the same for everyone.
const columns = () => [
  {
    title: "Company Name",
    dataIndex: "name",
    key: "name",
    render: (name: string, data: orgList) => (
      <div className={styles.tableMember}>
        <div className={styles.tableMemberImg}>
          <Avatar
            style={{ backgroundColor: ORG_AVATAR_COLOR, color: "#ffffff" }}
            sx={{ width: 32, height: 32, fontSize: "13px", fontWeight: 600, borderRadius: "8px" }}
          >
            {name?.charAt(0).toLocaleUpperCase()}
          </Avatar>
        </div>
        <div className={styles.tableMemberDetail}>
          <div className={styles.tableMemberName}>{name}</div>
          {data?.abn && <div className={styles.tableMemberEmail}>{data.abn}</div>}
        </div>
      </div>
    )
  },
  {
    // CPC-69: the client's identifier (their code for the account in UGC)
    // is stored in the organisation contact name field in this deployment.
    title: "Client Identifier",
    dataIndex: "referenceName",
    key: "referenceName",
    render: (referenceName: string) => (
      <div className={styles.tableRole}>
        <div className={styles.tableRoleName}>{referenceName || "—"}</div>
      </div>
    )
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt: string) => <DateStack value={createdAt} />
  },
  {
    title: "Status",
    dataIndex: "active",
    key: "active",
    render: (active: boolean) => (
      <div className={styles.tableStatus}>
        <div className={active ? styles.green : styles.grey}>{active ? "Active" : "Archived"}</div>
      </div>
    )
  },
  {
    title: "Access Client",
    dataIndex: EMPTY_STRING,
    key: "operations",
    render: (data: { organisationId: string; active: boolean }) => {
      return data.active && <AdminSwitchOrg orgId={data.organisationId} />;
    }
  }
];

export default columns;
